import ScallopTop from "./svgs/Scallop top.svg";
import ScallopBottom from "./svgs/Scallop bottom.svg";
import ShieldTop from "./svgs/Shield top.svg";
import ShieldBottom from "./svgs/Shield bottom.svg";
import SquareTop from "./svgs/Square top.svg";
import SquareBottom from "./svgs/Square bottom.svg";
import KiteTop from "./svgs/Kite top.svg";
import KiteBottom from "./svgs/Kite bottom.svg";
import MuffinTop from "./svgs/Mushroom top.svg";
import MuffinBottom from "./svgs/Mushroom bottom.svg";
import RightFistTop from "./svgs/Right fist top.svg";
import RightFistBottom from "./svgs/Right fist bottom.svg";
import LeftFistTop from "./svgs/Left fist top.svg";
import LeftFistBottom from "./svgs/Left fist bottom.svg";
import BarrelTop from "./svgs/Barrel top.svg";
import BarrelBottom from "./svgs/Barrel bottom.svg";
import Right51 from "./svgs/Right 5-1.svg";
import Left51 from "./svgs/Left 5-1.svg";
import Right42 from "./svgs/Right 4-2.svg";
import Left42 from "./svgs/Left 4-2.svg";
import LeftPawnTop from "./svgs/Left pawn top.svg";
import LeftPawnBottom from "./svgs/Left pawn bottom.svg";
import RightPawnTop from "./svgs/Right pawn top.svg";
import RightPawnBottom from "./svgs/Right pawn bottom.svg";
import Case8 from "./svgs/8.svg";
import Case71 from "./svgs/7-1.svg";
import Case53 from "./svgs/5-3.svg";
import Case62 from "./svgs/6-2.svg";
import Case44 from "./svgs/4-4.svg";
import Case222 from "./svgs/2-2-2.svg";
import Case6 from "./svgs/6.svg";
import Case33 from "./svgs/3-3.svg";
import Case411 from "./svgs/4-1-1.svg";
import Case321 from "./svgs/3-2-1.svg";
import Case312 from "./svgs/3-1-2.svg";
import Star from "./svgs/Star.svg";
import PerpendicularEdges from "./svgs/Perpendicular edges.svg";
import ParallelEdges from "./svgs/Parallel edges.svg";
import PairedEdges from "./svgs/Paired edges.svg";

export const AllCases = [
  {
    name: "Kite/Square",
    top: KiteTop,
    bottom: SquareBottom,
    odd: ["3,0/1,0/-2,0/2,0/-2,0/1,0/3,0/ (-1,1)"],
    even: ["3,1/-1,0/2,0/-2,0/2,0/-1,0/-3,0/"],
    oddPar: [4],
    evenPar: [4],
    good: 7,
    bad: 7,
    probability: 16,
  },
  {
    name: "7-1/Star",
    top: Case71,
    bottom: Star,
    odd: ["0,2/0,-2/-1,-2/2,-3/-2,-1/-3,0/ (-1,1)"],
    even: ["/0,-2/-1,-2/2,-3/-2,-1/-3,0/ (-1,1)"],
    oddPar: [1],
    evenPar: [1],
    good: 6,
    bad: 6,
    probability: 16,
  },
  {
    name: "5-3/Star",
    top: Case53,
    bottom: Star,
    odd: [
      "1,2/4,0/1,0/3,-2/2,1/0,3/",
      "-4,2/2,-2/-3,-2/-2,3/-1,-2/-3,0/",
      "-5,0/0,4/1,0/-2,3/-1,-2/-3,0/",
    ],
    even: [
      "1,0/4,0/1,0/3,-2/2,1/0,3/",
      "-4,0/2,-2/-3,-2/-2,3/-1,-2/-3,0/",
      "-5,2/0,4/1,0/-2,3/-1,-2/-3,0/",
    ],
    oddPar: [1, 1, 1],
    evenPar: [1, 1, 1],
    good: 6,
    bad: 6,
    probability: 16,
  },
  {
    name: "2-2-2/Perpendicular Edges",
    top: Case222,
    bottom: PerpendicularEdges,
    odd: ["/-1,0/2,0/0,-2/0,1/0,3/"],
    even: ["0,2/1,0/-2,0/0,2/0,-1/0,-3/ (-1,1)"],
    oddPar: [1],
    evenPar: [1],
    good: 6,
    bad: 6,
    probability: 16,
  },
  {
    name: "2-2-2/Parallel Edges",
    top: Case222,
    bottom: ParallelEdges,
    odd: ["-2,0/3,0/0,2/0,-2/0,1/0,3/"],
    even: ["-2,0/-3,0/0,-2/0,2/0,-1/0,-3/ (-1,1)"],
    oddPar: [4],
    evenPar: [4],
    good: 6,
    bad: 6,
    probability: 8,
  },
  {
    name: "Muffin/Right Fist",
    top: MuffinTop,
    bottom: RightFistBottom,
    odd: [
      "1,0/0,4/1,2/0,-2/-1,4/-3,0/",
      "1,-4/1,-2/2,1/2,-2/1,0/-3,-3/",
      "1,2/1,-2/2,-3/3,-2/-2,-1/0,-3/ (-1,1)",
    ],
    even: [
      "1,0/0,4/-1,0/0,2/4,-1/0,-3/ (-1,1)",
      "1,-4/1,-2/0,-1/0,2/-1,-2/-3,-3/",
      "1,2/-3,2/3,0/-3,2/-2,-1/0,-3/ (-1,1)",
    ],
    oddPar: [3, 3, 2],
    evenPar: [3, 3, 2],
    good: 6,
    bad: 6,
    probability: 48,
  },
  {
    name: "Muffin/Left Fist",
    top: MuffinTop,
    bottom: LeftFistBottom,
    odd: [
      "/-4,0/1,0/-2,0/-4,1/3,0/",
      "0,4/2,-1/0,1/-2,0/-2,-1/3,3/",
      "0,-2/-2,3/-3,0/-2,3/-1,-2/-3,0/",
    ],
    even: [
      "/-4,0/-1,-2/2,0/4,-1/-3,0/ (-1,1)",
      "0,4/2,-1/-2,-1/2,-2/-1,0/-3,-3/",
      "0,-2/2,-1/-2,3/2,-3/-1,-2/-3,0/",
    ],
    oddPar: [3, 3, 2],
    evenPar: [3, 3, 2],
    good: 6,
    bad: 6,
    probability: 48,
  },
  {
    name: "Muffin/Kite",
    top: MuffinTop,
    bottom: KiteBottom,
    odd: ["0,3/2,1/0,-2/2,0/-1,-2/-3,-3/"],
    even: ["0,3/2,-1/0,2/-2,0/-2,-1/3,3/"],
    oddPar: [3],
    evenPar: [3],
    good: 6,
    bad: 6,
    probability: 32,
  },
  {
    name: "Muffin/Barrel",
    top: MuffinTop,
    bottom: BarrelBottom,
    odd: [
      "0,-2/-2,0/0,2/2,-3/-2,-1/-3,0/ (-1,1)",
      "1,0/3,-2/2,0/0,-2/1,0/0,3/ (-1,1)",
    ],
    even: [
      "0,-2/2,-1/-2,0/-2,3/-2,-1/-3,0/ (-1,1)",
      "/2,-3/-2,0/2,0/-1,0/-3,0/",
    ],
    oddPar: [2, 3],
    evenPar: [2, 3],
    good: 6,
    bad: 6,
    probability: 32,
  },
  {
    name: "Kite/Right Fist",
    top: KiteTop,
    bottom: RightFistBottom,
    odd: ["0,2/0,2/3,-2/0,2/-2,-1/0,-3/ (-1,1)"],
    even: ["0,2/0,2/1,0/0,-2/2,1/0,3/"],
    oddPar: [3],
    evenPar: [3],
    good: 6,
    bad: 6,
    probability: 48,
  },
  {
    name: "Kite/Left Fist",
    top: KiteTop,
    bottom: LeftFistBottom,
    odd: ["0,-2/-2,0/-3,2/-2,0/-1,-2/-3,0/"],
    even: ["0,-2/-2,0/-1,0/2,0/-2,-1/-3,0/ (-1,1)"],
    oddPar: [3],
    evenPar: [3],
    probability: 48,
  },
  {
    name: "Barrel/Right Fist",
    top: BarrelTop,
    bottom: RightFistBottom,
    odd: ["2,-3/0,2/0,1/0,-2/-2,-1/3,3/"],
    even: ["2,-3/0,2/-2,-1/-2,2/-1,0/-3,-3/"],
    oddPar: [3],
    evenPar: [3],
    good: 6,
    bad: 6,
    probability: 48,
  },
  {
    name: "Barrel/Left Fist",
    top: BarrelTop,
    bottom: LeftFistBottom,
    odd: ["-2,-3/0,-2/0,-1/0,2/-1,-2/-3,-3/"],
    even: ["-2,-3/0,-2/2,1/2,-2/1,0/-3,-3/"],
    oddPar: [3],
    evenPar: [3],
    good: 6,
    bad: 6,
    probability: 48,
  },
  {
    name: "Right Fist/Right Fist",
    top: RightFistTop,
    bottom: RightFistBottom,
    odd: ["0,-4/-4,0/2,0/-2,0/1,0/3,0/ (-1,1)"],
    even: ["2,6/2,0/-2,0/2,0/-1,0/-3,0/"],
    oddPar: [3],
    evenPar: [3],
    good: 6,
    bad: 6,
    probability: 36,
  },
  {
    name: "Left Fist/Left Fist",
    top: LeftFistTop,
    bottom: LeftFistBottom,
    odd: ["6,-2/4,0/-2,0/2,0/-1,0/-3,0/"],
    even: ["4,0/-2,0/2,0/-2,0/1,0/3,0/ (-1,1)"],
    oddPar: [3],
    evenPar: [3],
    good: 6,
    bad: 6,
    probability: 36,
  },
  {
    name: "Left Fist/Square",
    top: LeftFistTop,
    bottom: SquareBottom,
    odd: ["-2,0/0,4/-1,-2/0,2/-2,-1/0,-3/ (-1,1)"],
    even: ["-2,0/0,-2/0,1/0,2/-1,0/0,-3/"],
    oddPar: [3],
    evenPar: [3],
    good: 6,
    bad: 6,
    probability: 24,
  },
  {
    name: "Right Fist/Square",
    top: RightFistTop,
    bottom: SquareBottom,
    odd: ["2,1/2,0/0,-1/-2,0/1,0/3,0/ (-1,1)"],
    even: ["2,1/-4,0/1,2/-2,0/-1,-2/-3,0/"],
    oddPar: [3],
    evenPar: [3],
    good: 6,
    bad: 6,
    probability: 24,
  },
  {
    name: "Barrel/Square",
    top: BarrelTop,
    bottom: SquareBottom,
    odd: ["0,1/2,0/2,0/-2,0/2,0/-1,0/-3,0/"],
    even: ["/-2,0/-2,0/2,0/-2,0/1,0/3,0/ (-1,1)"],
    oddPar: [4],
    evenPar: [4],
    good: 6,
    bad: 6,
    probability: 16,
  },
  {
    name: "6/Perpendicular Edges",
    top: Case6,
    bottom: PerpendicularEdges,
    odd: ["2,-4/-2,-3/-3,2/2,1/0,3/"],
    even: ["/3,2/3,-2/2,1/0,3/"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 5,
    probability: 48,
  },
  {
    name: "6/Parallel Edges",
    top: Case6,
    bottom: ParallelEdges,
    odd: ["/0,-4/2,-3/-2,-1/-3,0/ (-1,1)"],
    even: ["-4,0/0,4/-2,3/-1,-2/-3,0/"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 5,
    probability: 24,
  },
  {
    name: "Left 5-1/Parallel Edges",
    top: Left51,
    bottom: ParallelEdges,
    odd: ["/3,0/0,4/-2,-1/0,-3/ (-1,1)"],
    even: ["-4,0/-1,4/2,-2/0,-1/3,3/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 24,
  },
  {
    name: "Right 5-1/Parallel Edges",
    top: Right51,
    bottom: ParallelEdges,
    odd: ["-2,0/1,-4/-2,2/0,1/3,3/"],
    even: ["6,0/-3,0/0,-4/2,1/0,3/"],
    oddPar: [2],
    evenPar: [2],
    probability: 24,
  },
  {
    name: "Left 4-2/Perpendicular Edges",
    top: Left42,
    bottom: PerpendicularEdges,
    odd: ["0,2/-3,2/-3,2/-2,-1/0,-3/ (-1,1)"],
    even: ["2,0/3,0/3,-2/2,1/0,3/"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 5,
    probability: 64,
  },
  {
    name: "Right 4-2/Perpendicular Edges",
    top: Right42,
    bottom: PerpendicularEdges,
    odd: ["-2,2/-3,0/-3,2/-2,-1/0,-3/ (-1,1)"],
    even: ["/3,-2/3,-2/2,1/0,3/"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 5,
    probability: 64,
  },
  {
    name: "3-3/Paired Edges",
    top: Case33,
    bottom: PairedEdges,
    odd: ["-1,4/0,2/-3,0/-2,-1/0,-3/ (-1,1)"],
    even: ["-1,0/0,-2/3,0/2,1/0,3/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 72,
  },
  {
    name: "3-3/Parallel Edges",
    top: Case33,
    bottom: ParallelEdges,
    odd: ["-2,0/1,0/-1,0/0,2/-2,-1/3,3/"],
    even: ["/-1,0/1,0/0,-2/-1,-2/-3,-3"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 24,
  },
  {
    name: "4-1-1/Parallel Edges",
    top: Case411,
    bottom: ParallelEdges,
    odd: ["-3,0/-3,2/0,-4/2,1/0,3/"],
    even: ["-1,0/3,-2/0,4/-2,-1/0,-3/ (-1,1)"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 32,
  },
  {
    name: "3-1-2/Paired Edges",
    top: Case312,
    bottom: PairedEdges,
    odd: [
      "0,-2/0,-5/3,-2/-2,-1/0,-3/ (-1,1)",
      "3,0/0,-4/0,-2/4,-1/-3,0/ (-1,1)",
    ],
    even: ["-3,2/2,0/0,-2/0,1/0,3/"],
    oddPar: [2, 2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 72,
  },
  {
    name: "3-2-1/Paired Edges",
    top: Case321,
    bottom: PairedEdges,
    odd: ["3,0/5,0/-3,2/-2,-1/0,-3/ (-1,1)", "/4,0/0,2/4,-1/0,-3/ (-1,1)"],
    even: ["0,2/-2,0/0,2/0,-1/0,-3/ (-1,1)"],
    oddPar: [2, 2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 72,
  },
  {
    name: "3-1-2/Parallel Edges",
    top: Case312,
    bottom: ParallelEdges,
    odd: ["3,0/0,2/1,0/-3,-1/0,-3/ (-1,1)"],
    even: ["6,0/1,-4/-2,0/-1,-2/-3,-3/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 24,
  },
  {
    name: "3-2-1/Parallel Edges",
    top: Case321,
    bottom: ParallelEdges,
    odd: ["6,0/0,-2/-1,0/3,1/0,3/"],
    even: ["3,0/-1,4/2,0/-2,-1/3,3"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 24,
  },
  {
    name: "Scallop/Right Pawn",
    top: ScallopTop,
    bottom: RightPawnBottom,
    odd: ["0,4/-1,-2/-3,2/-2,-1/0,-3/ (-1,1)"],
    even: ["-4,0/2,3/2,-3/-1,-2/-3,0/"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 5,
    probability: 48,
  },
  {
    name: "Scallop/Left Pawn",
    top: ScallopTop,
    bottom: LeftPawnBottom,
    odd: ["4,0/-3,-2/-2,3/-1,-2/-3,0/"],
    even: ["0,-4/2,1/3,-2/-2,-1/0,-3/ (-1,1)"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 5,
    probability: 48,
  },
  {
    name: "Scallop/Shield",
    top: ScallopTop,
    bottom: ShieldBottom,
    odd: ["4,-4/0,-2/2,0/-2,-1/3,3/"],
    even: ["2,0/0,2/-2,0/-1,-2/-3,-3/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 72,
  },
  {
    name: "Scallop/Muffin",
    top: ScallopTop,
    bottom: MuffinBottom,
    odd: ["2,0/0,-2/-2,3/-1,-2/-3,0/"],
    even: ["-2,1/2,0/2,-3/-1,-2/-3,0/"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 5,
    probability: 48,
  },
  {
    name: "Scallop/Left Fist",
    top: ScallopTop,
    bottom: LeftFistBottom,
    odd: ["-2,-2/2,-3/-2,3/-2,-1/-3,0/ (-1,1)"],
    even: ["-4,0/0,3/2,-3/-1,-2/-3,0/"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 5,
    probability: 72,
  },
  {
    name: "Scallop/Right Fist",
    top: ScallopTop,
    bottom: RightFistBottom,
    odd: ["2,2/3,-2/2,-3/-2,-1/-3,0/ (-1,1)"],
    even: ["4,0/-3,0/-2,3/-1,-2/-3,0/"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 5,
    probability: 72,
  },
  {
    name: "Scallop/Square",
    top: ScallopTop,
    bottom: SquareBottom,
    odd: ["2,1/0,2/-2,0/-1,-2/-3,0/", "-4,1/2,0/-2,0/-2,-2/-3,0/ (-1,1)"],
    even: ["-2,0/-2,0/2,0/-1,-2/-3,0/", "4,0/0,-2/2,0/-2,-1/-3,0/ (-1,1)"],
    oddPar: [2, 2],
    evenPar: [2, 2],
    good: 5,
    bad: 5,
    probability: 24,
  },
  {
    name: "Left Pawn/Shield",
    top: LeftPawnTop,
    bottom: ShieldBottom,
    odd: ["2,-2/0,-2/1,0/-2,3/-1,-2/-3,0/"],
    even: ["2,-4/1,0/-2,3/-1,-2/-3,0/"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 6,
    probability: 48,
  },
  {
    name: "Right Pawn/Shield",
    top: RightPawnTop,
    bottom: ShieldBottom,
    odd: ["4,-2/0,2/-1,0/2,-3/-2,-1/-3,0/ (-1,1)"],
    even: ["4,0/-1,0/2,-3/-2,-1/-3,0/ (-1,1)"],
    oddPar: [1],
    evenPar: [1],
    good: 5,
    bad: 6,
    probability: 48,
  },
  {
    name: "Right Pawn/Right Pawn",
    top: RightPawnTop,
    bottom: RightPawnBottom,
    odd: ["-2,-2/0,1/2,2/-1,0/-3,-3/"],
    even: ["-2,-2/0,-1/2,2/-1,-2/-3,-3/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 16,
  },
  {
    name: "Left Pawn/Left Pawn",
    top: LeftPawnTop,
    bottom: LeftPawnBottom,
    odd: ["2,2/-1,0/-2,-2/0,1/3,3/"],
    even: ["2,2/1,0/-2,-2/-1,-2/-3,-3/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 16,
  },
  {
    name: "Right Pawn/Muffin",
    top: RightPawnTop,
    bottom: MuffinBottom,
    odd: ["-2,1/2,1/-2,2/1,0/-3,-3/"],
    even: ["-2,1/0,-1/2,0/-1,-2/-3,-3/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 32,
  },
  {
    name: "Left Pawn/Muffin",
    top: LeftPawnTop,
    bottom: MuffinBottom,
    odd: ["2,0/-1,-2/2,-2/0,-1/3,3/"],
    even: ["2,0/1,0/-2,0/-1,-2/-3,-3/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 32,
  },
  {
    name: "Right Pawn/Right Fist",
    top: RightPawnTop,
    bottom: RightFistBottom,
    odd: ["-2,2/0,2/-2,0/4,-1/0,-3/ (-1,1)"],
    even: ["-2,2/-2,0/2,0/-1,4/-3,0/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 48,
  },
  {
    name: "Left Pawn/Left Fist",
    top: LeftPawnTop,
    bottom: LeftFistBottom,
    odd: ["2,-2/0,2/-2,0/-4,1/3,0/"],
    even: ["2,-2/-2,0/2,0/4,-1/-3,0/ (-1,1)"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 48,
  },
  {
    name: "Right Pawn/Kite",
    top: RightPawnTop,
    bottom: KiteBottom,
    odd: ["4,0/-1,-2/2,0/-2,-1/-3,0/ (-1,1)", "-2,3/-2,-1/2,0/-1,-2/-3,-3"],
    even: ["-2,0/0,1/2,0/-1,0/-3,0/", "4,0/-3,0/-2,0/-1,-2/-3,0/"],
    oddPar: [2, 2],
    evenPar: [2, 2],
    good: 5,
    bad: 5,
    probability: 32,
  },
  {
    name: "Left Pawn/Kite",
    top: LeftPawnTop,
    bottom: KiteBottom,
    odd: ["-4,0/2,1/-2,0/-2,-1/-3,0/ (-1,1)", "2,-3/1,2/-2,0/-1,-2/-3,-3/"],
    even: ["2,0/-1,0/-2,0/0,1/3,0/", "-4,0/0,3/2,0/-1,-2/-3,0/"],
    oddPar: [2, 2],
    evenPar: [2, 2],
    good: 5,
    bad: 5,
    probability: 32,
  },
  {
    name: "Right Pawn/Barrel",
    top: RightPawnTop,
    bottom: BarrelBottom,
    odd: ["-2,-2/2,-1/2,-3/-1,-2/-3,0/"],
    even: ["0,2/2,0/3,-2/2,-3/-2,-1/-3,0/ (-1,1)"],
    oddPar: [1],
    evenPar: [2],
    good: 5,
    bad: 6,
    probability: 32,
  },
  {
    name: "Left Pawn/Barrel",
    top: LeftPawnTop,
    bottom: BarrelBottom,
    odd: ["2,2/1,-2/-2,3/-1,-2/-3,0/"],
    even: ["0,-2/0,-2/-3,2/3,-2/2,1/0,3/"],
    oddPar: [1],
    evenPar: [2],
    good: 5,
    bad: 6,
    probability: 32,
  },
  {
    name: "Right Pawn/Square",
    top: RightPawnTop,
    bottom: SquareBottom,
    odd: ["-2,1/0,-1/2,0/-1,-2/-3,0/"],
    even: ["-2,1/2,-3/-2,0/-2,-1/-3,0/ (-1,1)"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 16,
  },
  {
    name: "Left Pawn/Square",
    top: LeftPawnTop,
    bottom: SquareBottom,
    odd: ["2,0/1,0/-2,0/-1,-2/-3,0/"],
    even: ["2,0/3,-2/2,0/-2,-1/-3,0/ (-1,1)"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 16,
  },
  {
    name: "Shield/Left Fist",
    top: ShieldTop,
    bottom: LeftFistBottom,
    odd: ["-2,3/0,1/-2,0/4,-1/0,-3/ (-1,1)"],
    even: ["-2,3/-2,-1/2,0/-1,4/-3,0/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 72,
  },
  {
    name: "Shield/Right Fist",
    top: ShieldTop,
    bottom: RightFistBottom,
    odd: ["-2,3/2,1/-2,0/4,-1/0,-3/ (-1,1)"],
    even: ["-2,3/0,-1/2,0/-1,4/-3,0/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 72,
  },
  {
    name: "Shield/Kite",
    top: ShieldTop,
    bottom: KiteBottom,
    odd: ["4,0/0,-2/2,0/0,-1/-3,0/ (-1,1)"],
    even: ["-2,0/2,0/-2,0/1,0/3,0/ (-1,1)"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 48,
  },
  {
    name: "Shield/Barrel",
    top: ShieldTop,
    bottom: BarrelBottom,
    odd: ["-2,2/0,2/-2,0/-2,-1/3,3/"],
    even: ["-2,-2/0,-2/2,0/-1,-2/-3,-3/"],
    oddPar: [2],
    evenPar: [2],
    good: 5,
    bad: 5,
    probability: 48,
  },
  {
    name: "8/Star",
    top: Case8,
    bottom: Star,
    odd: ["/2,4/-2,-1/3,3/"],
    even: ["0,2/2,4/-2,-1/3,3/"],
    oddPar: [1],
    evenPar: [1],
    good: 4,
    bad: 4,
    probability: 16,
  },
  {
    name: "6-2/Star",
    top: Case62,
    bottom: Star,
    odd: ["/2,4/4,-1/-3,0/ (-1,1)"],
    even: ["0,2/2,4/4,-1/-3,0/ (-1,1)"],
    oddPar: [1],
    evenPar: [1],
    good: 4,
    bad: 4,
    probability: 16,
  },
  {
    name: "4-4/Star",
    top: Case44,
    bottom: Star,
    odd: ["/-2,-2/0,1/3,3/", "-2,2/2,2/-2,-1/3,3/"],
    even: ["0,2/-2,-2/0,1/3,3/", "-2,0/2,2/-2,-1/3,3/"],
    oddPar: [1, 1],
    evenPar: [1, 1],
    good: 4,
    bad: 4,
    probability: 10,
  },
  {
    name: "6/Paired Edges",
    top: Case6,
    bottom: PairedEdges,
    odd: ["2,0/0,4/-2,-1/3,3/"],
    even: ["0,-2/-4,0/-1,-2/-3,-3/"],
    oddPar: [1],
    evenPar: [1],
    good: 4,
    bad: 4,
    probability: 72,
  },
  {
    name: "Left 5-1/Paired Edges",
    top: Left51,
    bottom: PairedEdges,
    odd: ["3,2/3,0/2,-2/0,2/-2,-1/0,-3/ (-1,1)"],
    even: ["3,2/3,-2/2,1/0,3/"],
    oddPar: [3],
    evenPar: [1],
    good: 4,
    bad: 6,
    probability: 72,
  },
  {
    name: "Right 5-1/Paired Edges",
    top: Right51,
    bottom: PairedEdges,
    odd: ["3,2/-3,2/-2,-1/0,-3/ (-1,1)"],
    even: ["3,2/-3,0/-2,2/0,-2/2,1/0,3/"],
    oddPar: [1],
    evenPar: [3],
    good: 4,
    bad: 6,
    probability: 72,
  },
  {
    name: "Left 5-1/Perpendicular Edges",
    top: Left51,
    bottom: PerpendicularEdges,
    odd: ["0,-4/-4,0/-1,-2/-3,0/"],
    even: ["0,2/-2,4/-2,0/-1,-2/-3,0/"],
    oddPar: [1],
    evenPar: [2],
    good: 4,
    bad: 5,
    probability: 48,
  },
  {
    name: "Right 5-1/Perpendicular Edges",
    top: Right51,
    bottom: PerpendicularEdges,
    odd: ["/0,4/-2,-1/0,-3/ (-1,1)"],
    even: ["6,0/2,4/2,0/-2,-1/-3,0/ (-1,1)"],
    oddPar: [1],
    evenPar: [2],
    good: 4,
    bad: 5,
    probability: 48,
  },
  {
    name: "Left 4-2/Paired Edges",
    top: Left42,
    bottom: PairedEdges,
    odd: ["0,-2/-2,0/-1,-2/-3,-3/"],
    even: ["-2,-4/2,-2/0,-1/3,3/"],
    oddPar: [1],
    evenPar: [1],
    good: 4,
    bad: 4,
    probability: 96,
  },
  {
    name: "Right 4-2/Paired Edges",
    top: Right42,
    bottom: PairedEdges,
    odd: ["2,-4/-2,2/0,1/3,3/"],
    even: ["0,6/2,0/-2,-1/3,3/"],
    oddPar: [1],
    evenPar: [1],
    good: 4,
    bad: 4,
    probability: 96,
  },
  {
    name: "Left 4-2/Parallel Edges",
    top: Left42,
    bottom: ParallelEdges,
    odd: ["-4,0/3,2/-2,-1/0,-3/ (-1,1)"],
    even: ["/0,-4/-2,3/-1,-2/-3,0/"],
    oddPar: [1],
    evenPar: [2],
    good: 4,
    bad: 5,
    probability: 32,
  },
  {
    name: "Right 4-2/Parallel Edges",
    top: Right42,
    bottom: ParallelEdges,
    odd: ["/0,4/2,-3/-2,-1/-3,0/ (-1,1)"],
    even: ["4,0/-3,-2/2,1/0,3/"],
    oddPar: [2],
    evenPar: [1],
    good: 4,
    bad: 5,
    probability: 32,
  },
  {
    name: "3-3/Perpendicular Edges",
    top: Case33,
    bottom: PerpendicularEdges,
    odd: ["0,2/0,-2/-1,4/-3,0/"],
    even: ["-2,0/0,2/4,-1/0,-3/ (-1,1)"],
    oddPar: [1],
    evenPar: [1],
    good: 4,
    bad: 4,
    probability: 48,
  },
  {
    name: "4-1-1/Paired Edges",
    top: Case411,
    bottom: PairedEdges,
    odd: ["0,-2/-4,0/-1,4/-3,0/"],
    even: ["2,2/0,4/4,-1/-3,0/ (-1,1)"],
    oddPar: [1],
    evenPar: [1],
    good: 4,
    bad: 4,
    probability: 96,
  },
  {
    name: "4-1-1/Perpendicular Edges",
    top: Case411,
    bottom: PerpendicularEdges,
    odd: ["3,2/0,-2/2,1/0,3/"],
    even: ["5,0/0,2/-2,-1/0,-3/ (-1,1)"],
    oddPar: [1],
    evenPar: [1],
    good: 4,
    bad: 4,
    probability: 64,
  },
  {
    name: "3-1-2/Perpendicular Edges",
    top: Case312,
    bottom: PerpendicularEdges,
    odd: ["4,0/0,2/0,-1/0,-3/ (-1,1)"],
    even: ["-2,2/0,-4/-2,0/0,1/3,0/"],
    oddPar: [1],
    evenPar: [2],
    good: 4,
    bad: 5,
    probability: 48,
  },
  {
    name: "3-2-1/Perpendicular Edges",
    top: Case321,
    bottom: PerpendicularEdges,
    odd: ["-1,-4/-2,0/0,1/3,0/"],
    even: ["-1,0/0,4/2,0/0,-1/-3,0/ (-1,1)"],
    oddPar: [1],
    evenPar: [2],
    good: 4,
    bad: 5,
    probability: 48,
  },
  {
    name: "2-2-2/Paired Edges",
    top: Case222,
    bottom: PairedEdges,
    odd: ["-2,0/0,2/0,-1/3,3/"],
    even: ["0,-2/-2,0/0,1/3,3/"],
    oddPar: [1],
    evenPar: [1],
    good: 4,
    bad: 4,
    probability: 24,
  },
  {
    name: "Scallop/Barrel",
    top: ScallopBottom,
    bottom: BarrelBottom,
    odd: ["4,2/-4,0/2,0/-1,-2/-3,-3/"],
    even: ["/4,0/-1,0/-3,-3/"],
    oddPar: [2],
    evenPar: [1],
    good: 4,
    bad: 5,
    probability: 48,
  },
  {
    name: "Right Pawn/Left Fist",
    top: RightPawnTop,
    bottom: LeftFistBottom,
    odd: ["/0,1/-1,0/-3,0/"],
    even: ["-2,-2/4,0/-4,0/4,-1/-3,0/ (-1,1)"],
    oddPar: [1],
    evenPar: [2],
    good: 4,
    bad: 5,
    probability: 48,
  },
  {
    name: "Left Pawn/Right Fist",
    top: LeftPawnTop,
    bottom: RightFistBottom,
    odd: ["/-1,0/1,0/0,3/ (-1,1)"],
    even: ["2,2/0,-4/4,0/4,-1/0,-3/ (-1,1)"],
    oddPar: [1],
    evenPar: [2],
    good: 4,
    bad: 5,
    probability: 48,
  },
  {
    name: "Shield/Muffin",
    top: ShieldTop,
    bottom: MuffinBottom,
    odd: ["0,6/0,-3/-1,-2/-3,0/"],
    even: ["-2,1/4,0/2,0/0,-3/-1,-2/-3,0/"],
    oddPar: [1],
    evenPar: [3],
    good: 4,
    bad: 6,
    probability: 48,
  },
  {
    name: "Scallop/Scallop",
    top: ScallopTop,
    bottom: ScallopBottom,
    odd: ["/-1,-2/-3,-3/"],
    even: ["2,-2/-2,2/-1,-2/-3,-3/"],
    oddPar: [0],
    evenPar: [1],
    good: 3,
    bad: 4,
    probability: 36,
  },
  {
    name: "Scallop/Kite",
    top: ScallopTop,
    bottom: KiteBottom,
    odd: ["/-1,-2/-3,0/"],
    even: ["2,0/2,-2/2,0/-2,-1/-3,0/ (-1,1)"],
    oddPar: [0],
    evenPar: [2],
    good: 3,
    bad: 5,
    probability: 48,
  },
  {
    name: "Left Pawn/Right Pawn",
    top: LeftPawnTop,
    bottom: RightPawnBottom,
    odd: ["2,-2/-2,2/-4,1/3,0/"],
    even: ["/-4,1/3,0/"],
    oddPar: [1],
    evenPar: [0],
    good: 3,
    bad: 4,
    probability: 32,
  },
  {
    name: "Shield/Shield",
    top: ShieldTop,
    bottom: ShieldBottom,
    odd: ["/-1,0/-3,-3/"],
    even: ["4,-2/-4,2/-1,0/-3,-3/"],
    oddPar: [0],
    evenPar: [1],
    good: 3,
    bad: 4,
    probability: 36,
  },
  {
    name: "Shield/Square",
    top: ShieldTop,
    bottom: SquareBottom,
    odd: ["0,1/-1,0/-3,0/"],
    even: ["0,1/0,-4/-2,2/-2,2/4,-1/0,-3/ (-1,1)"],
    oddPar: [0],
    evenPar: [3],
    good: 3,
    bad: 6,
    probability: 24,
  },
  {
    name: "Muffin/Muffin",
    top: MuffinTop,
    bottom: MuffinBottom,
    odd: ["6,0/1,0/2,-2/-2,2/-1,-2/-3,-3/"],
    even: ["6,0/0,-2/-3,-3/"],
    oddPar: [4],
    evenPar: [1],
    good: 3,
    bad: 6,
    probability: 16,
  },
  {
    name: "Muffin/Square",
    top: MuffinTop,
    bottom: SquareBottom,
    odd: ["/-2,0/-3,0/ (-1,1)"],
    even: ["1,1/5,0/-2,2/2,-2/4,-1/-3,0/ (-1,1)"],
    oddPar: [1],
    evenPar: [4],
    good: 3,
    bad: 6,
    probability: 16,
  },
  {
    name: "Kite/Barrel",
    top: KiteTop,
    bottom: BarrelBottom,
    odd: ["/4,2/-2,2/-2,2/4,-1/0,-3/ (-1,1)"],
    even: ["/0,3/0,3/"],
    oddPar: [4],
    evenPar: [1],
    good: 3,
    bad: 6,
    probability: 32,
  },
  {
    name: "Left Fist/Right Fist",
    top: LeftFistTop,
    bottom: RightFistBottom,
    odd: ["0,3/0,3/"],
    even: ["-2,-4/2,-2/-2,2/-4,1/3,0/"],
    oddPar: [0],
    evenPar: [3],
    good: 2,
    bad: 5,
    probability: 72,
  },
  {
    name: "Barrel/Barrel",
    top: BarrelTop,
    bottom: BarrelBottom,
    odd: ["-3,0/-3,-3/"],
    even: ["-2,2/2,-2/-2,2/-1,-2/-3,-3/"],
    oddPar: [0],
    evenPar: [3],
    good: 2,
    bad: 5,
    probability: 16,
  },
  {
    name: "Kite/Kite",
    top: KiteTop,
    bottom: KiteBottom,
    odd: ["-3,3/-2,-1/2,-2/-2,2/-1,-2/-3,-3/"],
    even: ["0,6/"],
    oddPar: [5],
    evenPar: [0],
    good: 1,
    bad: 6,
    probability: 16,
  },
  {
    name: "Square/Square",
    top: SquareTop,
    bottom: SquareBottom,
    odd: ["/3,3/1,2/2,-2/-2,2/-1,-2/-3,-3/"],
    even: ["Done!"],
    oddPar: [7],
    evenPar: [0],
    good: 0,
    bad: 7,
    probability: 4,
  },
];
